/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Dialog_TitleInputs */

const es_landing_dialog_title = /** @type {(inputs: Landing_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tú controlas las condiciones del alquiler`)
};

const gl_landing_dialog_title = /** @type {(inputs: Landing_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti controlas as condicións do alugueiro`)
};

const en_landing_dialog_title = /** @type {(inputs: Landing_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You control the rental terms`)
};

/**
* | output |
* | --- |
* | "You control the rental terms" |
*
* @param {Landing_Dialog_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_dialog_title = /** @type {((inputs?: Landing_Dialog_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Dialog_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_dialog_title(inputs)
	if (locale === "en") return en_landing_dialog_title(inputs)
	return es_landing_dialog_title(inputs)
});